"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import { createSVGIconV2 } from "@faire/web/slate/icons/lib/createSVGIconV2";
import React from "react";

// Implemented using the icons from here: https://faire-wholesale.slack.com/archives/C08PZGMUC3Z/p1756238353493689?thread_ts=1756237700.863289&cid=C08PZGMUC3Z
export const CartEmpty = createSVGIconV2(
  <>
    <circle cx="9" cy="20" r="1.5" fill="currentColor" stroke="currentColor" />
    <circle cx="18" cy="20" r="1.5" fill="currentColor" stroke="currentColor" />
    <path
      d="M2 2H3.65287C4.14171 2 4.5589 2.35341 4.63927 2.8356L5 5M5 5H20.905C21.493 5 21.9541 5.50492 21.9009 6.09054L21.0827 15.0905C21.0359 15.6056 20.604 16 20.0868 16H6.91321C6.39601 16 5.96415 15.6056 5.91732 15.0905L5 5Z"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </>,
  "CartEmpty",
  {
    color: Core.icon.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
